import {useCallback} from 'react';
import {postRefreshToken} from '../../../api/auth/postRefreshToken';
import {requestContext} from '../../../common/requestContext';
import {useInterval} from '../../../common/useInterval.hook';

export function useRefreshToken() {
  const process = useCallback(async () => {
    // 웹뷰는 일회용 토큰으로 들어오기 때문에 refresh_token 을 호출하지 않습니다(호출해도 소용 없습니다)
    if (requestContext.requestInfo.display.isWebView) {
      return;
    }

    await postRefreshToken();
  }, []);

  // 30분에 한 번씩 리프레시 합니다
  useInterval(process, 30 * 60 * 1000);
}
